import { Routes, Route } from "react-router-dom";

import UserManagement from "./UserManagement/UserManagement";
import TechDashboard from "./TechAdmin/TechDashboard";

import AdminLogin from "./AdminLogin";
import BlogsAdmin from "./BlogsAdmin/BlogsAdmin";
import CreateBlogs from "./BlogsAdmin/CreateBlogs";
import EditBlog from "./BlogsAdmin/EditBlog";
import AdminLogs from "../AdminLogs";

import CaseStudiesAdmin from "./CaseStudiesAdmin/CaseStudiesAdmin";
import CreateCaseStudies from "./CaseStudiesAdmin/CreateCaseStudies";
import EditCaseStudy from "./CaseStudiesAdmin/EditCaseStudy";

import AdminLayout from "../../components/Layouts/AdminLayout";

import RATalksManagement from './RoadAheadTalks_Admin/RATalksManagement';
import ExpertManagement from './RoadAheadTalks_Admin/ExpertManagement';
import CreateWebinar from './RoadAheadTalks_Admin/CreateWebinar';
import EditWebinar from './RoadAheadTalks_Admin/EditWebinar';
import CreateRecordedVideo from './RoadAheadTalks_Admin/CreateRecordedVideo';
import AddFeaturedExpert from './RoadAheadTalks_Admin/AddFeaturedExpert';
import EditExpert from './RoadAheadTalks_Admin/EditExpert';
import WebsiteContent from './WebsiteContentAdmin/WebsiteContent';
import HrContent from './HrContentAdmin/HrContent';
import CreateLearningMaterial from "./HrContentAdmin/components/CreateLearningMaterial";
import EditLearningMaterial from "./HrContentAdmin/components/EditLearningMaterial";

// import Redirection from './WebsiteContentAdmin/Redirection';

import FormsManagement from "./FormsManagement";
import ViewForm from "./ViewForm";

import { RequireToken } from "../../Auth";
import CreateForm from "./FormsAdmin/CreateForm";
import Home from "./Home"

const Admin = ({ match }) => {
  return (
    <Routes>
      <Route path="login" element={<AdminLogin />} />

      {/* user management and dashboard management routes (only for super admin) */}
      <Route
        path="home"
        element={
          <RequireToken>
            <AdminLayout>
              <Home />
            </AdminLayout>
          </RequireToken>
        }
      />

      <Route
        path="user-management"
        element={
          <RequireToken>
            <AdminLayout>
              <UserManagement />
            </AdminLayout>
          </RequireToken>
        }
      />

       <Route
        path="tech-dashboard"
        element={
          <RequireToken>
            <AdminLayout>
              <TechDashboard />
            </AdminLayout>
          </RequireToken>
        }
      />

      {/* blog admin routes */}
      <Route
        path="blogs-admin/create-blog"
        element={
          <RequireToken>
            <AdminLayout>
              <CreateBlogs />
            </AdminLayout>
          </RequireToken>
        }
      />
      <Route
        path="blogs-admin/edit-blog/:blogId"
        element={
          <AdminLayout>
            <EditBlog />
          </AdminLayout>
        }
      />

      <Route
        path="blogs-admin"
        element={
          <RequireToken>
            <AdminLayout>
              <BlogsAdmin />
            </AdminLayout>
          </RequireToken>
        }
      />

      <Route
        path="admin-logs"
        element={
          <AdminLayout>
            <AdminLogs />
          </AdminLayout>
        }
      />

      {/* case studies admin routes */}
      <Route
        path="case-studies-admin/create-case-study"
        element={
          <RequireToken>
            <AdminLayout>
              <CreateCaseStudies />
            </AdminLayout>
          </RequireToken>
        }
      />
      <Route
        path="case-studies-admin/edit-case-study/:caseStudyId"
        element={
          <AdminLayout>
            <EditCaseStudy />
          </AdminLayout>
        }
      />
      <Route
        path="case-studies-admin"
        element={
          <RequireToken>
            <AdminLayout>
              <CaseStudiesAdmin />
            </AdminLayout>
          </RequireToken>
        }
      />


      {/* roadahead talks routes */}
      <Route
        path="road-ahead-talks-management"
        element={
          <RequireToken>
            <AdminLayout>
              <RATalksManagement />
            </AdminLayout>
          </RequireToken>
        }
      />
      <Route
        path="expert-management"
        element={
          <RequireToken>
            <AdminLayout>
              <ExpertManagement />
            </AdminLayout>
          </RequireToken>
        }
      />
      <Route
        path="create-webinar"
        element={
          <RequireToken>
            <AdminLayout>
              <CreateWebinar />
            </AdminLayout>
          </RequireToken>
        }
      />
      <Route
        path="edit-webinar/:url"
        element={
          <RequireToken>
            <AdminLayout>
              <EditWebinar />
            </AdminLayout>
          </RequireToken>
        }
      />
      <Route
        path="create-recorded-video"
        element={
          <RequireToken>
            <AdminLayout>
              <CreateRecordedVideo />
            </AdminLayout>
          </RequireToken>
        }
      />
      <Route
        path="add-expert"
        element={
          <RequireToken>
            <AdminLayout>
              <AddFeaturedExpert />
            </AdminLayout>
          </RequireToken>
        }
      />
      <Route
        path="edit-expert/:id"
        element={
          <RequireToken>
            <AdminLayout>
              <EditExpert />
            </AdminLayout>
          </RequireToken>
        }
      />

      {/* form management routes */}
      <Route
        path="forms-management"
        element={
          <AdminLayout>
            <FormsManagement />
          </AdminLayout>
        }
      />
      <Route
        path="forms-management/:form_name"
        element={
          <AdminLayout>
            <ViewForm />
          </AdminLayout>
        }
      />

      <Route
        path="create-form"
        element={
          <AdminLayout>
            <CreateForm />
          </AdminLayout>
        }
      />

      {/* Road ahead shorts routes */}
      <Route
        path="website-content"
        element={
          <RequireToken>
            <AdminLayout isWebsiteContent={true}>
              <WebsiteContent />
            </AdminLayout>
          </RequireToken>
        }
      />
       <Route
          path="hr-content/learning-material-management/create"
          element={
            <RequireToken>
              <AdminLayout >
                <CreateLearningMaterial />
              </AdminLayout>
            </RequireToken>
          }
        />
         <Route
        path="hr-content/learning-material-management/edit/:pageURL"
        element={
          <RequireToken>
            <AdminLayout >
              <EditLearningMaterial />
            </AdminLayout>
          </RequireToken>
        }
      />
      <Route
        path="hr-content/*"
        element={
          <RequireToken>
            <AdminLayout isWebsiteContent={true}>
              <HrContent />
            </AdminLayout>
          </RequireToken>
        }
      />
    </Routes>
  );


 
};

export default Admin;
